/* eslint-disable jira/filename-case */
import {
	type HydrationOutcomeReporter,
	captureDocumentState,
} from '@jira/platform__hydration-preservation-tracker/src/preservationTracker.tsx';

export type RegionHydrationReport = Record<string, HydrationOutcomeReporter>;

/**
 * collects preservation metrics from different page layout slots
 */
export const getRegionPreservationMetrics = (
	report: RegionHydrationReport | undefined = {},
): Record<string, number> => {
	return Object.entries(report || {}).reduce<Record<string, number>>(
		(acc, [regionName, reporter]) => {
			const outcome = reporter();
			// report in 100% basis for easier reading in analytics tools
			acc[regionName] = 100 * outcome.preservationRatio;
			return acc;
		},
		{},
	);
};
/**
 * collects information separately for different page layout slots
 */
export const setupRegionReporters = (
	rootContainer: HTMLElement,
	captureHydrationState = false,
): RegionHydrationReport => {
	const regions = rootContainer.querySelectorAll<HTMLElement>('[data-layout-slot]');
	if (!regions) {
		return {};
	}
	const reporters = Array.from(regions).reduce<RegionHydrationReport>((acc, region) => {
		const regionName = region.getAttribute('data-testid');
		if (!regionName) {
			return acc;
		}
		// extension point - track hydration mistakes per region
		acc[regionName] = captureDocumentState(region);
		return acc;
	}, {});

	reporters.root = captureDocumentState(rootContainer, {
		captureBoundaryData: captureHydrationState,
	});
	return reporters;
};
